import React, { useRef } from "react";
import backgroundImage from "~/images/modal-background-image.png";
import { Close } from "@mui/icons-material";
import { createPortal } from "react-dom";
import useOutsideClick from "../../Hooks/useOutsideClick";

const RegistrationResultModal = (props) => {
  const modalRef = useRef();
  useOutsideClick(modalRef, props.closeModal);

  const titles = {
    active: { title: "Enrollment Successful" },
    pending: { title: "Enrollment in Review" },
    error: { title: "Enrollment Error" },
  };

  const status = props.registrationResult?.status;
  const content = titles[status] || titles.error;
  const showEntityCard = status === "active" || status === "pending";

  const subtitle =
    props.registrationResult?.notice ||
    props.registrationResult?.error ||
    "There was an issue submitting your New Entity Enrollment. Please try again.";

  const renderEntityInfo = () => {
    return (
      <div className="bg br--8 pa--16">
        <div className="entity-registration__card_container">
          <div className="flex__container justify-content-center align-items-center">
            <div className="entity-registration__avatar mr--8">
              <span className="entity-registration__avatar">
                {props.registrationResult?.entity_name[0]}
              </span>
            </div>
          </div>
          <div className="entity-registration__details">
            <div className={"entity-registration__name"}>
              {props.registrationResult?.entity_name}
            </div>
            <div className="entity-registration__id">{props.registrationResult?.id_340b}</div>
          </div>
        </div>
      </div>
    );
  };

  return createPortal(
    <div className="entity-registration__background">
      <div className="entity-registration__container" ref={modalRef}>
        <div className="entity-registration__header">
          <div className="entity-registration__header__img">
            <img src={backgroundImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={props.closeModal}>
            <Close />
          </div>
        </div>
        <div className="entity-registration__body">
          <div className="t--xl t--500">{content.title}</div>
          {showEntityCard && <div>{renderEntityInfo()}</div>}
          <div className="t--subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
          <div className="flex justify-content-end">
            <button
              className="button button--blue t--500"
              style={{ width: "100%" }}
              onClick={props.closeModal}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RegistrationResultModal;
